//
// theme.js
//

// Vendor
import 'bootstrap';
import 'flickity';
import 'flickity-imagesloaded';
import 'flickity-as-nav-for';
import 'flickity-fade';

// Theme
import './bootstrap';
import './countup';
import './flickity';
import './highlight';
import './map';
import './navbar-dropdown';
import './navbar-reveal';
import './navbar-toggle';
import './password';
import './popovers';
import './price';
import './prices';
import './table-features';
import './table';
import './tooltips';
import './typed';

// User
import './user.js';

// Svelte
import App from '../svelte/App.svelte';
const target = document.getElementById('svelte_app') || document.createElement('div');
const app = new App({target});
export default app;